import React, { Suspense } from 'react';
import { Route } from 'react-router';
import {
    hrPayrollPeriodSettings,
    ruleInputCodeSettings,
    salaryRuleSettings,
    salaryStructureSettings,
} from '../constants/constants';
import GenericSettingContainer from '../containers/GenericSettingContainer/GenericSettingContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const HrPayrollPeriodSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/HrPayrollPeriodSettingsPage'));
const SalaryStructureSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/SalaryStructureSettingsPage'));
const SalaryRuleSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/SalaryRuleSettingsPage'));
const RuleInputCodeSettingsPage = React.lazy(() => import('../pages/MiscSettingsPages/RuleInputCodeSettingsPage'));

const PayrollSettingsRoutes = props => (
    <GenericSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={hrPayrollPeriodSettings} exact component={HrPayrollPeriodSettingsPage} />
            <Route path={salaryStructureSettings} exact component={SalaryStructureSettingsPage} />
            <Route path={salaryRuleSettings} exact component={SalaryRuleSettingsPage} />
            <Route path={ruleInputCodeSettings} exact component={RuleInputCodeSettingsPage} />
        </Suspense>
    </GenericSettingContainer>
);

export default PayrollSettingsRoutes;
